import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Droplets, Activity } from 'lucide-react';
const painPoints = [{
  icon: <Heart className="w-6 h-6" data-id="element-156" />,
  title: 'Baja autoestima',
  description: 'Sentís que el espejo no refleja la vitalidad y energía que llevás por dentro.'
}, {
  icon: <Activity className="w-6 h-6" data-id="element-157" />,
  title: 'Cansancio visible',
  description: 'El estrés diario deja marcas en tu rostro que el maquillaje ya no puede ocultar.'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-158" />,
  title: 'Piel sin luminosidad',
  description: 'Notás tu piel opaca, deshidratada o con texturas irregulares que te incomodan.'
}, {
  icon: <Droplets className="w-6 h-6" data-id="element-159" />,
  title: 'Cambios corporales',
  description: 'Tu cuerpo cambió y buscás recuperar la firmeza y armonía de forma natural.'
}];
export function PainPoints() {
  return <section className="py-24 bg-softwhite relative overflow-hidden" data-id="element-160">
      <div className="container mx-auto px-6 md:px-12" data-id="element-161">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-162">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-serif text-deepblack mb-6" data-id="element-163">
            Sabemos cómo te <span className="italic text-rosegold" data-id="element-164">sentís</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg text-deepblack/70 font-sans font-light" data-id="element-165">
            Entendemos que la belleza no es superficial; es cómo te sentís con
            vos misma. Estamos acá para acompañarte en tu proceso de
            transformación.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-166">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-nude p-8 rounded-2xl border border-nude-dark hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-167">
              <div className="w-14 h-14 rounded-full bg-rosegold/10 text-rosegold flex items-center justify-center mb-6 group-hover:bg-rosegold group-hover:text-white transition-colors duration-300" data-id="element-168">
                {point.icon}
              </div>
              <h3 className="text-xl font-serif font-medium text-deepblack mb-3" data-id="element-169">
                {point.title}
              </h3>
              <p className="text-sm font-sans text-deepblack/70 leading-relaxed" data-id="element-170">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}